import './App.css';
import './Section.css';
import './Game.css';
import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from './Component/Home';
import Minegame from './Component/Minegame';
import Dicegame from './Component/Dicegame';
import Login from './Component/Login';
import Spinwheel from './Component/Spinwheel';
import Coinflip from './Component/Coinflip';
import Layout from './Component/Layout';

import { AuthProvider, useAuth } from './context/AuthContext';
import Terms from './Component/Terms';
import Privacy from './Component/Privacy';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <MainApp />
      </BrowserRouter>
    </AuthProvider>
  );
}

function MainApp() {
  const { openLogin, setOpenLogin, isAuth } = useAuth();

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={<Home />}
          />
          <Route
            path="minegame"
            element={
              <Minegame
                setOpenLogin={setOpenLogin}
                isAuth={isAuth}
              />
            }
          />
          <Route
            path="dicegame"
            element={
              <Dicegame
                setOpenLogin={setOpenLogin}
                isAuth={isAuth}
              />
            }
          />
          <Route
            path="spinwheel"
            element={
              <Spinwheel
                setOpenLogin={setOpenLogin}
                isAuth={isAuth}
              />
            }
          />
          <Route
            path="coinflip"
            element={
              <Coinflip
                setOpenLogin={setOpenLogin}
                isAuth={isAuth}
              />
            }
          />

          <Route
            path="terms"
            element={
              <Terms/>
            }
          />

          <Route
          path='Privacy-Policy'
          element={<Privacy/>}
          />

        </Route>
      </Routes>


      {openLogin && (
        <Login onClose={() => setOpenLogin(false)} />
      )}


      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="dark"
      />
    </>
  );
}

export default App;